import { useCallback, useEffect, useState } from 'react'
import {
  TorchApplicationData,
  TorchApplicationTypes,
  useTorchApplication,
} from '../../components/TorchApplicationContext'
import { Page2FullFilm } from './Page2FullFilm'
import { Page2Torch } from './Page2Torch'

const cleanValue = (value: string | string[] | boolean) => {
  if (typeof value !== 'string') return value

  return value?.trim() || ''
}

export const Details = () => {
  const { type, updateData, data } = useTorchApplication()
  const [controlledData, setControlledData] = useState(data || ({} as TorchApplicationData))

  useEffect(() => {
    setControlledData(data || ({} as TorchApplicationData))
  }, [data])

  const onSaveData = useCallback(
    ({ name, value }: { name: string; value: string | string[] | boolean }) => {
      const cleanedValue = cleanValue(value)
      updateData({ [name]: cleanedValue ?? null })
    },
    [updateData],
  )

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const key = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      setControlledData((current) => ({ ...current, [key]: value || null }))
    },
    [],
  )

  const handleSelectChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const name = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      onSaveData({ name, value })
    },
    [onSaveData],
  )

  const handleInputBlur = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const key = (event.currentTarget.id || event.currentTarget.name) as keyof TorchApplicationData
      const value = event.currentTarget.value
      onSaveData({ name: key, value })
    },
    [onSaveData],
  )

  if (type === TorchApplicationTypes.FullFilm) {
    return (
      <Page2FullFilm
        data={controlledData}
        onSaveData={onSaveData}
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
      />
    )
  }

  return (
    <Page2Torch
      data={controlledData}
      onSaveData={onSaveData}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      handleInputBlur={handleInputBlur}
    />
  )
}
